import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import UserService from "services/user-service";

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const response = await UserService.fetchUserDetails();
        console.log("User Details : ", response);
        // [NEW] Sort by last_login descending (primary) then created_at (secondary)
        const sortedUsers = response.sort((a, b) => {
          const dateA = a.last_login ? new Date(a.last_login) : new Date(0);
          const dateB = b.last_login ? new Date(b.last_login) : new Date(0);
          return dateB - dateA;
        });
        setUsers(sortedUsers);
      } catch (err) {
        console.error("Failed to fetch users:", err.message);
        setError("Unable to load users. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" mt={4}>
        <CircularProgress color="accent" />
      </MDBox>
    );
  }

  if (error) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" mt={4}>
        <MDTypography color="error">{error}</MDTypography>
      </MDBox>
    );
  }

  // ✅ Define table columns
  const columns = [
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            ID
          </MDTypography>
        </MDBox>
      ),
      accessor: "id", // Virtual field from mongoose schema
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            NAME
          </MDTypography>
        </MDBox>
      ),
      accessor: "name",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            EMAIL
          </MDTypography>
        </MDBox>
      ),
      accessor: "email",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            ROLE
          </MDTypography>
        </MDBox>
      ),
      accessor: "role",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            STATUS
          </MDTypography>
        </MDBox>
      ),
      accessor: "status",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            JOINED ON
          </MDTypography>
        </MDBox>
      ),
      accessor: "created_at",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            LAST LOGIN
          </MDTypography>
        </MDBox>
      ),
      accessor: "last_login",
      align: "left",
    },
  ];

  // ✅ Format user data into rows
  const rows = users.map((user) => ({
    id: user.id || user._id,
    name: user.name,
    email: user.email,
    role: user.role || "User",
    status: user.email_verified_at ? "Verified" : "Unverified",
    created_at: new Date(user.created_at).toLocaleDateString(),
    last_login: user.last_login ? new Date(user.last_login).toLocaleString() : "Never",
  }));

  return (
    <Card sx={{ mb: 3, mt: 7, overflow: "visible" }}>
      <MDBox
        mx={2}
        mt={-3}
        py={2}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" color="white">
          User Management
        </MDTypography>
      </MDBox>

      <MDBox p={2}>
        <DataTable
          canSearch={true}
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={5}
        />
      </MDBox>
    </Card>
  );
}

export default Users;
